import React from 'react';
import SectionHeader from './SectionHeader';
import { PANDI } from '../mock';

export default function Character() {
  return (
    <section id="pandi" className="section-pad bg-[#0a0807]">
      <div className="container-narrow">
        <SectionHeader chapter={PANDI.chapter} label={PANDI.label} heading={PANDI.heading} />
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <p className="font-serif text-[19px] md:text-[20px] leading-[1.75] text-[color:var(--bx-bone)]/85">{PANDI.body}</p>
          </div>
          <div className="lg:col-span-5">
            <div className="glass-panel p-6 space-y-5">
              {PANDI.meta.map((m, i) => (
                <div key={i} className="flex items-start justify-between gap-6 pb-4 border-b border-[color:var(--bx-gold)]/15 last:border-0 last:pb-0">
                  <div className="font-sc text-[10px] gold-text tracking-[0.4em] pt-1">{m.k}</div>
                  <div className="font-serif text-[16px] text-[color:var(--bx-bone)]/90 text-right max-w-[60%]">{m.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 max-w-5xl mx-auto">
          {PANDI.plates.map((pl, i) => (
            <div key={i} className="plate w-full" style={{ aspectRatio: '21 / 9' }}>
              <img src={pl.img} alt={pl.title} loading="lazy" />
              <div className="plate-meta">
                <div>
                  <div className="font-sc text-[10px] gold-text tracking-[0.4em]">{pl.n}</div>
                  <div className="font-sc text-[10px] text-[color:var(--bx-bone)]/80 tracking-[0.32em] mt-1">{pl.title}</div>
                </div>
                <div className="font-mono text-[10px] text-[color:var(--bx-muted)]">21 : 9</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
